module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/local-audits"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Back to Audits on Device")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.auditVersions), function(audit, index) {
    return _c('li', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          _vm.showAuditVersion(index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\tVersion #" + _vm._s(index + 1) + "\n\t\t\t\t")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-sm-8"
  }, [_c('h3', [_vm._v("Raw Audit Data (Version #" + _vm._s(_vm.activeAuditNum) + ")")]), _vm._v(" "), _c('p', [_vm._v("Provide this data to the developer to recover into a useful audit")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.activeAudit))]), _vm._v(" "), (_vm.activeAuditObj) ? _c('article', [_c('h2', [_vm._v("Audit")]), _vm._v(" "), _vm._l((_vm.activeAuditObj.auditData.form_values), function(section) {
    return _c('div', {
      staticClass: "section"
    }, [_c('h3', [_vm._v(_vm._s(section.heading))]), _vm._v(" "), ('fields' in section) ? _c('table', {
      staticClass: "table table-sm"
    }, [_c('tbody', _vm._l((section.fields), function(field) {
      return _c('tr', [_c('th', [_vm._v(_vm._s(field.question))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(field.value))])])
    }))]) : _vm._e(), _vm._v(" "), _vm._l((section.subSections), function(subSection) {
      return ('subSections' in section) ? _c('div', {
        staticClass: "subsection"
      }, [_c('h4', [_vm._v(_vm._s(subSection.heading))]), _vm._v(" "), ('fields' in subSection) ? _c('table', {
        staticClass: "table table-sm"
      }, [_c('tbody', _vm._l((subSection.fields), function(field) {
        return _c('tr', [_c('th', [_vm._v(_vm._s(field.question))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(field.value))])])
      }))]) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()
    })], 2)
  })], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-addbcc56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LocalAudit.vue
// module id = 304
// module chunks = 0